import { Link } from 'react-router-dom';
import { Calendar, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { StatusBadge } from '../ui';

export interface LinkedBookingItem {
  id: string;
  bookingReference?: string | null;
  status: string;
  bookingType?: string | null;
  scheduledAt?: number | null;
  isCurrent?: boolean;
  caseId?: string | null;
}

interface Props {
  title?: string;
  bookings: LinkedBookingItem[];
  emptyMessage?: string;
}

function formatDate(value?: number | null) {
  if (!value) return '—';
  return new Date(value * 1000).toLocaleString('es-ES', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export function LinkedBookingsSection({ title = 'Citas vinculadas', bookings, emptyMessage = 'No hay citas vinculadas.' }: Props) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-semibold">{title}</CardTitle>
          <div className="text-xs text-muted-foreground">{bookings.length}</div>
        </div>
      </CardHeader>
      <CardContent>
        {bookings.length === 0 ? (
          <div className="text-sm text-muted-foreground">{emptyMessage}</div>
        ) : (
          <div className="space-y-2">
            {bookings.map((b) => (
              <div key={b.id} className="rounded-lg border px-3 py-2 bg-gray-50">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0 space-y-0.5">
                    <div className="flex items-center gap-2">
                      <Calendar className="h-3.5 w-3.5 text-muted-foreground" />
                      <Link to={`/bookings/${b.id}`} className="text-sm font-medium text-blue-600 hover:underline">
                        {b.bookingReference || b.id}
                      </Link>
                      {b.isCurrent && <span className="text-[11px] text-blue-700">(actual)</span>}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {formatDate(b.scheduledAt)}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <StatusBadge status={b.status} bookingType={b.bookingType as any} />
                    {b.caseId && (
                      <Link to={`/cases/${b.caseId}`} className="text-[11px] text-primary hover:underline">
                        Caso
                      </Link>
                    )}
                    <Link
                      to={`/bookings/${b.id}`}
                      className="inline-flex items-center gap-1 text-xs text-gray-600 hover:text-gray-800"
                    >
                      Abrir <ExternalLink className="h-3 w-3" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
